/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LocaleRouteRouteImport } from './routes/$locale/route'
import { Route as LocalePartnerRouteRouteImport } from './routes/$locale/$partner/route'
import { Route as LocalePartnerIndexRouteImport } from './routes/$locale/$partner/index'
import { Route as LocalePartnerPageTypeRouteImport } from './routes/$locale/$partner/$pageType'
import { Route as LocalePartnerCameraRouteRouteImport } from './routes/$locale/$partner/_camera/route'
import { Route as LocalePartnerCosmeticRouteRouteImport } from './routes/$locale/$partner/_cosmetic/route'
import { Route as LocalePartnerDeviceRouteRouteImport } from './routes/$locale/$partner/_device/route'
import { Route as LocalePartnerEvaluationRouteRouteImport } from './routes/$locale/$partner/_evaluation/route'
import { Route as LocalePartnerOnboardingRouteRouteImport } from './routes/$locale/$partner/_onboarding/route'
import { Route as LocalePartnerResultsRouteRouteImport } from './routes/$locale/$partner/_results/route'
import { Route as LocalePartnerTradeInRouteRouteImport } from './routes/$locale/$partner/_trade-in/route'
import { Route as LocalePartnerTransitionsRouteRouteImport } from './routes/$locale/$partner/_transitions/route'
import { Route as LocalePartnerAddAssessmentsRouteImport } from './routes/$locale/$partner/add-assessments'
import { Route as LocalePartnerCameraBackCameraAiRouteImport } from './routes/$locale/$partner/_camera/back-camera-ai'
import { Route as LocalePartnerCameraFrontCameraAiRouteImport } from './routes/$locale/$partner/_camera/front-camera-ai'
import { Route as LocalePartnerCosmeticSelfBackCosmeticsRouteImport } from './routes/$locale/$partner/_cosmetic/self-back-cosmetics'
import { Route as LocalePartnerCosmeticSelfBodyFrameCosmeticsRouteImport } from './routes/$locale/$partner/_cosmetic/self-body-frame-cosmetics'
import { Route as LocalePartnerCosmeticSelfButtonsWorkRouteImport } from './routes/$locale/$partner/_cosmetic/self-buttons-work'
import { Route as LocalePartnerCosmeticSelfCameraCosmeticsRouteImport } from './routes/$locale/$partner/_cosmetic/self-camera-cosmetics'
import { Route as LocalePartnerCosmeticSelfFrontCosmeticsRouteImport } from './routes/$locale/$partner/_cosmetic/self-front-cosmetics'
import { Route as LocalePartnerCosmeticSelfLcdConditionRouteImport } from './routes/$locale/$partner/_cosmetic/self-lcd-condition'
import { Route as LocalePartnerDeviceDeviceIdentifiedRouteImport } from './routes/$locale/$partner/_device/device-identified'
import { Route as LocalePartnerDeviceImeiRouteImport } from './routes/$locale/$partner/_device/imei'
import { Route as LocalePartnerDeviceRevealImeiRouteImport } from './routes/$locale/$partner/_device/reveal-imei'
import { Route as LocalePartnerEvaluationAudioRouteImport } from './routes/$locale/$partner/_evaluation/audio'
import { Route as LocalePartnerEvaluationBiometricsRouteImport } from './routes/$locale/$partner/_evaluation/biometrics'
import { Route as LocalePartnerEvaluationDigitizerRouteImport } from './routes/$locale/$partner/_evaluation/digitizer'
import { Route as LocalePartnerEvaluationGyroscopeRouteImport } from './routes/$locale/$partner/_evaluation/gyroscope'
import { Route as LocalePartnerEvaluationMultitouchRouteImport } from './routes/$locale/$partner/_evaluation/multitouch'
import { Route as LocalePartnerOnboardingImpactRouteImport } from './routes/$locale/$partner/_onboarding/impact'
import { Route as LocalePartnerOnboardingInfoRouteImport } from './routes/$locale/$partner/_onboarding/info'
import { Route as LocalePartnerOnboardingStartRouteImport } from './routes/$locale/$partner/_onboarding/start'
import { Route as LocalePartnerOnboardingWhatYouNeedRouteImport } from './routes/$locale/$partner/_onboarding/what-you-need'
import { Route as LocalePartnerResultsAssessmentResultsRouteImport } from './routes/$locale/$partner/_results/assessment-results'
import { Route as LocalePartnerResultsOfferRouteImport } from './routes/$locale/$partner/_results/offer'
import { Route as LocalePartnerResultsStoredAssessmentResultsRouteImport } from './routes/$locale/$partner/_results/stored-assessment-results'
import { Route as LocalePartnerResultsUserInfoRouteImport } from './routes/$locale/$partner/_results/user-info'
import { Route as LocalePartnerTradeInStoreLocationsRouteImport } from './routes/$locale/$partner/_trade-in/store-locations'
import { Route as LocalePartnerTradeInTradeInCompletionRouteImport } from './routes/$locale/$partner/_trade-in/trade-in-completion'
import { Route as LocalePartnerTradeInTradeInCompletionFromHomeRouteImport } from './routes/$locale/$partner/_trade-in/trade-in-completion-from-home'
import { Route as LocalePartnerTradeInTradeInCompletionOnVisionRouteImport } from './routes/$locale/$partner/_trade-in/trade-in-completion-on-vision'
import { Route as LocalePartnerTransitionsRedirectionRouteImport } from './routes/$locale/$partner/_transitions/redirection'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleRouteRoute = LocaleRouteRouteImport.update({
  id: '/$locale',
  path: '/$locale',
  getParentRoute: () => rootRouteImport,
} as any)
const LocalePartnerRouteRoute = LocalePartnerRouteRouteImport.update({
  id: '/$partner',
  path: '/$partner',
  getParentRoute: () => LocaleRouteRoute,
} as any)
const LocalePartnerIndexRoute = LocalePartnerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocalePartnerRouteRoute,
} as any)
const LocalePartnerPageTypeRoute = LocalePartnerPageTypeRouteImport.update({
  id: '/$pageType',
  path: '/$pageType',
  getParentRoute: () => LocalePartnerRouteRoute,
} as any)
const LocalePartnerCameraRouteRoute =
  LocalePartnerCameraRouteRouteImport.update({
    id: '/_camera',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerCosmeticRouteRoute =
  LocalePartnerCosmeticRouteRouteImport.update({
    id: '/_cosmetic',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerDeviceRouteRoute =
  LocalePartnerDeviceRouteRouteImport.update({
    id: '/_device',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerEvaluationRouteRoute =
  LocalePartnerEvaluationRouteRouteImport.update({
    id: '/_evaluation',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerOnboardingRouteRoute =
  LocalePartnerOnboardingRouteRouteImport.update({
    id: '/_onboarding',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerResultsRouteRoute =
  LocalePartnerResultsRouteRouteImport.update({
    id: '/_results',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerTradeInRouteRoute =
  LocalePartnerTradeInRouteRouteImport.update({
    id: '/_trade-in',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerTransitionsRouteRoute =
  LocalePartnerTransitionsRouteRouteImport.update({
    id: '/_transitions',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerAddAssessmentsRoute =
  LocalePartnerAddAssessmentsRouteImport.update({
    id: '/add-assessments',
    path: '/add-assessments',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerCameraBackCameraAiRoute =
  LocalePartnerCameraBackCameraAiRouteImport.update({
    id: '/back-camera-ai',
    path: '/back-camera-ai',
    getParentRoute: () => LocalePartnerCameraRouteRoute,
  } as any)
const LocalePartnerCameraFrontCameraAiRoute =
  LocalePartnerCameraFrontCameraAiRouteImport.update({
    id: '/front-camera-ai',
    path: '/front-camera-ai',
    getParentRoute: () => LocalePartnerCameraRouteRoute,
  } as any)
const LocalePartnerCosmeticSelfBackCosmeticsRoute =
  LocalePartnerCosmeticSelfBackCosmeticsRouteImport.update({
    id: '/self-back-cosmetics',
    path: '/self-back-cosmetics',
    getParentRoute: () => LocalePartnerCosmeticRouteRoute,
  } as any)
const LocalePartnerCosmeticSelfBodyFrameCosmeticsRoute =
  LocalePartnerCosmeticSelfBodyFrameCosmeticsRouteImport.update({
    id: '/self-body-frame-cosmetics',
    path: '/self-body-frame-cosmetics',
    getParentRoute: () => LocalePartnerCosmeticRouteRoute,
  } as any)
const LocalePartnerCosmeticSelfButtonsWorkRoute =
  LocalePartnerCosmeticSelfButtonsWorkRouteImport.update({
    id: '/self-buttons-work',
    path: '/self-buttons-work',
    getParentRoute: () => LocalePartnerCosmeticRouteRoute,
  } as any)
const LocalePartnerCosmeticSelfCameraCosmeticsRoute =
  LocalePartnerCosmeticSelfCameraCosmeticsRouteImport.update({
    id: '/self-camera-cosmetics',
    path: '/self-camera-cosmetics',
    getParentRoute: () => LocalePartnerCosmeticRouteRoute,
  } as any)
const LocalePartnerCosmeticSelfFrontCosmeticsRoute =
  LocalePartnerCosmeticSelfFrontCosmeticsRouteImport.update({
    id: '/self-front-cosmetics',
    path: '/self-front-cosmetics',
    getParentRoute: () => LocalePartnerCosmeticRouteRoute,
  } as any)
const LocalePartnerCosmeticSelfLcdConditionRoute =
  LocalePartnerCosmeticSelfLcdConditionRouteImport.update({
    id: '/self-lcd-condition',
    path: '/self-lcd-condition',
    getParentRoute: () => LocalePartnerCosmeticRouteRoute,
  } as any)
const LocalePartnerDeviceDeviceIdentifiedRoute =
  LocalePartnerDeviceDeviceIdentifiedRouteImport.update({
    id: '/device-identified',
    path: '/device-identified',
    getParentRoute: () => LocalePartnerDeviceRouteRoute,
  } as any)
const LocalePartnerDeviceImeiRoute = LocalePartnerDeviceImeiRouteImport.update({
  id: '/imei',
  path: '/imei',
  getParentRoute: () => LocalePartnerDeviceRouteRoute,
} as any)
const LocalePartnerDeviceRevealImeiRoute =
  LocalePartnerDeviceRevealImeiRouteImport.update({
    id: '/reveal-imei',
    path: '/reveal-imei',
    getParentRoute: () => LocalePartnerDeviceRouteRoute,
  } as any)
const LocalePartnerEvaluationAudioRoute =
  LocalePartnerEvaluationAudioRouteImport.update({
    id: '/audio',
    path: '/audio',
    getParentRoute: () => LocalePartnerEvaluationRouteRoute,
  } as any)
const LocalePartnerEvaluationBiometricsRoute =
  LocalePartnerEvaluationBiometricsRouteImport.update({
    id: '/biometrics',
    path: '/biometrics',
    getParentRoute: () => LocalePartnerEvaluationRouteRoute,
  } as any)
const LocalePartnerEvaluationDigitizerRoute =
  LocalePartnerEvaluationDigitizerRouteImport.update({
    id: '/digitizer',
    path: '/digitizer',
    getParentRoute: () => LocalePartnerEvaluationRouteRoute,
  } as any)
const LocalePartnerEvaluationGyroscopeRoute =
  LocalePartnerEvaluationGyroscopeRouteImport.update({
    id: '/gyroscope',
    path: '/gyroscope',
    getParentRoute: () => LocalePartnerEvaluationRouteRoute,
  } as any)
const LocalePartnerEvaluationMultitouchRoute =
  LocalePartnerEvaluationMultitouchRouteImport.update({
    id: '/multitouch',
    path: '/multitouch',
    getParentRoute: () => LocalePartnerEvaluationRouteRoute,
  } as any)
const LocalePartnerOnboardingImpactRoute =
  LocalePartnerOnboardingImpactRouteImport.update({
    id: '/impact',
    path: '/impact',
    getParentRoute: () => LocalePartnerOnboardingRouteRoute,
  } as any)
const LocalePartnerOnboardingInfoRoute =
  LocalePartnerOnboardingInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => LocalePartnerOnboardingRouteRoute,
  } as any)
const LocalePartnerOnboardingStartRoute =
  LocalePartnerOnboardingStartRouteImport.update({
    id: '/start',
    path: '/start',
    getParentRoute: () => LocalePartnerOnboardingRouteRoute,
  } as any)
const LocalePartnerOnboardingWhatYouNeedRoute =
  LocalePartnerOnboardingWhatYouNeedRouteImport.update({
    id: '/what-you-need',
    path: '/what-you-need',
    getParentRoute: () => LocalePartnerOnboardingRouteRoute,
  } as any)
const LocalePartnerResultsAssessmentResultsRoute =
  LocalePartnerResultsAssessmentResultsRouteImport.update({
    id: '/assessment-results',
    path: '/assessment-results',
    getParentRoute: () => LocalePartnerResultsRouteRoute,
  } as any)
const LocalePartnerResultsOfferRoute =
  LocalePartnerResultsOfferRouteImport.update({
    id: '/offer',
    path: '/offer',
    getParentRoute: () => LocalePartnerResultsRouteRoute,
  } as any)
const LocalePartnerResultsStoredAssessmentResultsRoute =
  LocalePartnerResultsStoredAssessmentResultsRouteImport.update({
    id: '/stored-assessment-results',
    path: '/stored-assessment-results',
    getParentRoute: () => LocalePartnerResultsRouteRoute,
  } as any)
const LocalePartnerResultsUserInfoRoute =
  LocalePartnerResultsUserInfoRouteImport.update({
    id: '/user-info',
    path: '/user-info',
    getParentRoute: () => LocalePartnerResultsRouteRoute,
  } as any)
const LocalePartnerTradeInStoreLocationsRoute =
  LocalePartnerTradeInStoreLocationsRouteImport.update({
    id: '/store-locations',
    path: '/store-locations',
    getParentRoute: () => LocalePartnerTradeInRouteRoute,
  } as any)
const LocalePartnerTradeInTradeInCompletionRoute =
  LocalePartnerTradeInTradeInCompletionRouteImport.update({
    id: '/trade-in-completion',
    path: '/trade-in-completion',
    getParentRoute: () => LocalePartnerTradeInRouteRoute,
  } as any)
const LocalePartnerTradeInTradeInCompletionFromHomeRoute =
  LocalePartnerTradeInTradeInCompletionFromHomeRouteImport.update({
    id: '/trade-in-completion-from-home',
    path: '/trade-in-completion-from-home',
    getParentRoute: () => LocalePartnerTradeInRouteRoute,
  } as any)
const LocalePartnerTradeInTradeInCompletionOnVisionRoute =
  LocalePartnerTradeInTradeInCompletionOnVisionRouteImport.update({
    id: '/trade-in-completion-on-vision',
    path: '/trade-in-completion-on-vision',
    getParentRoute: () => LocalePartnerTradeInRouteRoute,
  } as any)
const LocalePartnerTransitionsRedirectionRoute =
  LocalePartnerTransitionsRedirectionRouteImport.update({
    id: '/redirection',
    path: '/redirection',
    getParentRoute: () => LocalePartnerTransitionsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$locale': typeof LocaleRouteRouteWithChildren
  '/$locale/$partner': typeof LocalePartnerRouteRouteWithChildren
  '/$locale/$partner/$pageType': typeof LocalePartnerPageTypeRoute
  '/$locale/$partner/add-assessments': typeof LocalePartnerAddAssessmentsRoute
  '/$locale/$partner/': typeof LocalePartnerIndexRoute
  '/$locale/$partner/back-camera-ai': typeof LocalePartnerCameraBackCameraAiRoute
  '/$locale/$partner/front-camera-ai': typeof LocalePartnerCameraFrontCameraAiRoute
  '/$locale/$partner/self-back-cosmetics': typeof LocalePartnerCosmeticSelfBackCosmeticsRoute
  '/$locale/$partner/self-body-frame-cosmetics': typeof LocalePartnerCosmeticSelfBodyFrameCosmeticsRoute
  '/$locale/$partner/self-buttons-work': typeof LocalePartnerCosmeticSelfButtonsWorkRoute
  '/$locale/$partner/self-camera-cosmetics': typeof LocalePartnerCosmeticSelfCameraCosmeticsRoute
  '/$locale/$partner/self-front-cosmetics': typeof LocalePartnerCosmeticSelfFrontCosmeticsRoute
  '/$locale/$partner/self-lcd-condition': typeof LocalePartnerCosmeticSelfLcdConditionRoute
  '/$locale/$partner/device-identified': typeof LocalePartnerDeviceDeviceIdentifiedRoute
  '/$locale/$partner/imei': typeof LocalePartnerDeviceImeiRoute
  '/$locale/$partner/reveal-imei': typeof LocalePartnerDeviceRevealImeiRoute
  '/$locale/$partner/audio': typeof LocalePartnerEvaluationAudioRoute
  '/$locale/$partner/biometrics': typeof LocalePartnerEvaluationBiometricsRoute
  '/$locale/$partner/digitizer': typeof LocalePartnerEvaluationDigitizerRoute
  '/$locale/$partner/gyroscope': typeof LocalePartnerEvaluationGyroscopeRoute
  '/$locale/$partner/multitouch': typeof LocalePartnerEvaluationMultitouchRoute
  '/$locale/$partner/impact': typeof LocalePartnerOnboardingImpactRoute
  '/$locale/$partner/info': typeof LocalePartnerOnboardingInfoRoute
  '/$locale/$partner/start': typeof LocalePartnerOnboardingStartRoute
  '/$locale/$partner/what-you-need': typeof LocalePartnerOnboardingWhatYouNeedRoute
  '/$locale/$partner/assessment-results': typeof LocalePartnerResultsAssessmentResultsRoute
  '/$locale/$partner/offer': typeof LocalePartnerResultsOfferRoute
  '/$locale/$partner/stored-assessment-results': typeof LocalePartnerResultsStoredAssessmentResultsRoute
  '/$locale/$partner/user-info': typeof LocalePartnerResultsUserInfoRoute
  '/$locale/$partner/store-locations': typeof LocalePartnerTradeInStoreLocationsRoute
  '/$locale/$partner/trade-in-completion': typeof LocalePartnerTradeInTradeInCompletionRoute
  '/$locale/$partner/trade-in-completion-from-home': typeof LocalePartnerTradeInTradeInCompletionFromHomeRoute
  '/$locale/$partner/trade-in-completion-on-vision': typeof LocalePartnerTradeInTradeInCompletionOnVisionRoute
  '/$locale/$partner/redirection': typeof LocalePartnerTransitionsRedirectionRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$locale': typeof LocaleRouteRouteWithChildren
  '/$locale/$partner': typeof LocalePartnerIndexRoute
  '/$locale/$partner/$pageType': typeof LocalePartnerPageTypeRoute
  '/$locale/$partner/add-assessments': typeof LocalePartnerAddAssessmentsRoute
  '/$locale/$partner/back-camera-ai': typeof LocalePartnerCameraBackCameraAiRoute
  '/$locale/$partner/front-camera-ai': typeof LocalePartnerCameraFrontCameraAiRoute
  '/$locale/$partner/self-back-cosmetics': typeof LocalePartnerCosmeticSelfBackCosmeticsRoute
  '/$locale/$partner/self-body-frame-cosmetics': typeof LocalePartnerCosmeticSelfBodyFrameCosmeticsRoute
  '/$locale/$partner/self-buttons-work': typeof LocalePartnerCosmeticSelfButtonsWorkRoute
  '/$locale/$partner/self-camera-cosmetics': typeof LocalePartnerCosmeticSelfCameraCosmeticsRoute
  '/$locale/$partner/self-front-cosmetics': typeof LocalePartnerCosmeticSelfFrontCosmeticsRoute
  '/$locale/$partner/self-lcd-condition': typeof LocalePartnerCosmeticSelfLcdConditionRoute
  '/$locale/$partner/device-identified': typeof LocalePartnerDeviceDeviceIdentifiedRoute
  '/$locale/$partner/imei': typeof LocalePartnerDeviceImeiRoute
  '/$locale/$partner/reveal-imei': typeof LocalePartnerDeviceRevealImeiRoute
  '/$locale/$partner/audio': typeof LocalePartnerEvaluationAudioRoute
  '/$locale/$partner/biometrics': typeof LocalePartnerEvaluationBiometricsRoute
  '/$locale/$partner/digitizer': typeof LocalePartnerEvaluationDigitizerRoute
  '/$locale/$partner/gyroscope': typeof LocalePartnerEvaluationGyroscopeRoute
  '/$locale/$partner/multitouch': typeof LocalePartnerEvaluationMultitouchRoute
  '/$locale/$partner/impact': typeof LocalePartnerOnboardingImpactRoute
  '/$locale/$partner/info': typeof LocalePartnerOnboardingInfoRoute
  '/$locale/$partner/start': typeof LocalePartnerOnboardingStartRoute
  '/$locale/$partner/what-you-need': typeof LocalePartnerOnboardingWhatYouNeedRoute
  '/$locale/$partner/assessment-results': typeof LocalePartnerResultsAssessmentResultsRoute
  '/$locale/$partner/offer': typeof LocalePartnerResultsOfferRoute
  '/$locale/$partner/stored-assessment-results': typeof LocalePartnerResultsStoredAssessmentResultsRoute
  '/$locale/$partner/user-info': typeof LocalePartnerResultsUserInfoRoute
  '/$locale/$partner/store-locations': typeof LocalePartnerTradeInStoreLocationsRoute
  '/$locale/$partner/trade-in-completion': typeof LocalePartnerTradeInTradeInCompletionRoute
  '/$locale/$partner/trade-in-completion-from-home': typeof LocalePartnerTradeInTradeInCompletionFromHomeRoute
  '/$locale/$partner/trade-in-completion-on-vision': typeof LocalePartnerTradeInTradeInCompletionOnVisionRoute
  '/$locale/$partner/redirection': typeof LocalePartnerTransitionsRedirectionRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$locale': typeof LocaleRouteRouteWithChildren
  '/$locale/$partner': typeof LocalePartnerRouteRouteWithChildren
  '/$locale/$partner/_camera': typeof LocalePartnerCameraRouteRouteWithChildren
  '/$locale/$partner/_cosmetic': typeof LocalePartnerCosmeticRouteRouteWithChildren
  '/$locale/$partner/_device': typeof LocalePartnerDeviceRouteRouteWithChildren
  '/$locale/$partner/_evaluation': typeof LocalePartnerEvaluationRouteRouteWithChildren
  '/$locale/$partner/_onboarding': typeof LocalePartnerOnboardingRouteRouteWithChildren
  '/$locale/$partner/_results': typeof LocalePartnerResultsRouteRouteWithChildren
  '/$locale/$partner/_trade-in': typeof LocalePartnerTradeInRouteRouteWithChildren
  '/$locale/$partner/_transitions': typeof LocalePartnerTransitionsRouteRouteWithChildren
  '/$locale/$partner/$pageType': typeof LocalePartnerPageTypeRoute
  '/$locale/$partner/add-assessments': typeof LocalePartnerAddAssessmentsRoute
  '/$locale/$partner/': typeof LocalePartnerIndexRoute
  '/$locale/$partner/_camera/back-camera-ai': typeof LocalePartnerCameraBackCameraAiRoute
  '/$locale/$partner/_camera/front-camera-ai': typeof LocalePartnerCameraFrontCameraAiRoute
  '/$locale/$partner/_cosmetic/self-back-cosmetics': typeof LocalePartnerCosmeticSelfBackCosmeticsRoute
  '/$locale/$partner/_cosmetic/self-body-frame-cosmetics': typeof LocalePartnerCosmeticSelfBodyFrameCosmeticsRoute
  '/$locale/$partner/_cosmetic/self-buttons-work': typeof LocalePartnerCosmeticSelfButtonsWorkRoute
  '/$locale/$partner/_cosmetic/self-camera-cosmetics': typeof LocalePartnerCosmeticSelfCameraCosmeticsRoute
  '/$locale/$partner/_cosmetic/self-front-cosmetics': typeof LocalePartnerCosmeticSelfFrontCosmeticsRoute
  '/$locale/$partner/_cosmetic/self-lcd-condition': typeof LocalePartnerCosmeticSelfLcdConditionRoute
  '/$locale/$partner/_device/device-identified': typeof LocalePartnerDeviceDeviceIdentifiedRoute
  '/$locale/$partner/_device/imei': typeof LocalePartnerDeviceImeiRoute
  '/$locale/$partner/_device/reveal-imei': typeof LocalePartnerDeviceRevealImeiRoute
  '/$locale/$partner/_evaluation/audio': typeof LocalePartnerEvaluationAudioRoute
  '/$locale/$partner/_evaluation/biometrics': typeof LocalePartnerEvaluationBiometricsRoute
  '/$locale/$partner/_evaluation/digitizer': typeof LocalePartnerEvaluationDigitizerRoute
  '/$locale/$partner/_evaluation/gyroscope': typeof LocalePartnerEvaluationGyroscopeRoute
  '/$locale/$partner/_evaluation/multitouch': typeof LocalePartnerEvaluationMultitouchRoute
  '/$locale/$partner/_onboarding/impact': typeof LocalePartnerOnboardingImpactRoute
  '/$locale/$partner/_onboarding/info': typeof LocalePartnerOnboardingInfoRoute
  '/$locale/$partner/_onboarding/start': typeof LocalePartnerOnboardingStartRoute
  '/$locale/$partner/_onboarding/what-you-need': typeof LocalePartnerOnboardingWhatYouNeedRoute
  '/$locale/$partner/_results/assessment-results': typeof LocalePartnerResultsAssessmentResultsRoute
  '/$locale/$partner/_results/offer': typeof LocalePartnerResultsOfferRoute
  '/$locale/$partner/_results/stored-assessment-results': typeof LocalePartnerResultsStoredAssessmentResultsRoute
  '/$locale/$partner/_results/user-info': typeof LocalePartnerResultsUserInfoRoute
  '/$locale/$partner/_trade-in/store-locations': typeof LocalePartnerTradeInStoreLocationsRoute
  '/$locale/$partner/_trade-in/trade-in-completion': typeof LocalePartnerTradeInTradeInCompletionRoute
  '/$locale/$partner/_trade-in/trade-in-completion-from-home': typeof LocalePartnerTradeInTradeInCompletionFromHomeRoute
  '/$locale/$partner/_trade-in/trade-in-completion-on-vision': typeof LocalePartnerTradeInTradeInCompletionOnVisionRoute
  '/$locale/$partner/_transitions/redirection': typeof LocalePartnerTransitionsRedirectionRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$locale'
    | '/$locale/$partner'
    | '/$locale/$partner/$pageType'
    | '/$locale/$partner/add-assessments'
    | '/$locale/$partner/'
    | '/$locale/$partner/back-camera-ai'
    | '/$locale/$partner/front-camera-ai'
    | '/$locale/$partner/self-back-cosmetics'
    | '/$locale/$partner/self-body-frame-cosmetics'
    | '/$locale/$partner/self-buttons-work'
    | '/$locale/$partner/self-camera-cosmetics'
    | '/$locale/$partner/self-front-cosmetics'
    | '/$locale/$partner/self-lcd-condition'
    | '/$locale/$partner/device-identified'
    | '/$locale/$partner/imei'
    | '/$locale/$partner/reveal-imei'
    | '/$locale/$partner/audio'
    | '/$locale/$partner/biometrics'
    | '/$locale/$partner/digitizer'
    | '/$locale/$partner/gyroscope'
    | '/$locale/$partner/multitouch'
    | '/$locale/$partner/impact'
    | '/$locale/$partner/info'
    | '/$locale/$partner/start'
    | '/$locale/$partner/what-you-need'
    | '/$locale/$partner/assessment-results'
    | '/$locale/$partner/offer'
    | '/$locale/$partner/stored-assessment-results'
    | '/$locale/$partner/user-info'
    | '/$locale/$partner/store-locations'
    | '/$locale/$partner/trade-in-completion'
    | '/$locale/$partner/trade-in-completion-from-home'
    | '/$locale/$partner/trade-in-completion-on-vision'
    | '/$locale/$partner/redirection'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$locale'
    | '/$locale/$partner'
    | '/$locale/$partner/$pageType'
    | '/$locale/$partner/add-assessments'
    | '/$locale/$partner/back-camera-ai'
    | '/$locale/$partner/front-camera-ai'
    | '/$locale/$partner/self-back-cosmetics'
    | '/$locale/$partner/self-body-frame-cosmetics'
    | '/$locale/$partner/self-buttons-work'
    | '/$locale/$partner/self-camera-cosmetics'
    | '/$locale/$partner/self-front-cosmetics'
    | '/$locale/$partner/self-lcd-condition'
    | '/$locale/$partner/device-identified'
    | '/$locale/$partner/imei'
    | '/$locale/$partner/reveal-imei'
    | '/$locale/$partner/audio'
    | '/$locale/$partner/biometrics'
    | '/$locale/$partner/digitizer'
    | '/$locale/$partner/gyroscope'
    | '/$locale/$partner/multitouch'
    | '/$locale/$partner/impact'
    | '/$locale/$partner/info'
    | '/$locale/$partner/start'
    | '/$locale/$partner/what-you-need'
    | '/$locale/$partner/assessment-results'
    | '/$locale/$partner/offer'
    | '/$locale/$partner/stored-assessment-results'
    | '/$locale/$partner/user-info'
    | '/$locale/$partner/store-locations'
    | '/$locale/$partner/trade-in-completion'
    | '/$locale/$partner/trade-in-completion-from-home'
    | '/$locale/$partner/trade-in-completion-on-vision'
    | '/$locale/$partner/redirection'
  id:
    | '__root__'
    | '/'
    | '/$locale'
    | '/$locale/$partner'
    | '/$locale/$partner/_camera'
    | '/$locale/$partner/_cosmetic'
    | '/$locale/$partner/_device'
    | '/$locale/$partner/_evaluation'
    | '/$locale/$partner/_onboarding'
    | '/$locale/$partner/_results'
    | '/$locale/$partner/_trade-in'
    | '/$locale/$partner/_transitions'
    | '/$locale/$partner/$pageType'
    | '/$locale/$partner/add-assessments'
    | '/$locale/$partner/'
    | '/$locale/$partner/_camera/back-camera-ai'
    | '/$locale/$partner/_camera/front-camera-ai'
    | '/$locale/$partner/_cosmetic/self-back-cosmetics'
    | '/$locale/$partner/_cosmetic/self-body-frame-cosmetics'
    | '/$locale/$partner/_cosmetic/self-buttons-work'
    | '/$locale/$partner/_cosmetic/self-camera-cosmetics'
    | '/$locale/$partner/_cosmetic/self-front-cosmetics'
    | '/$locale/$partner/_cosmetic/self-lcd-condition'
    | '/$locale/$partner/_device/device-identified'
    | '/$locale/$partner/_device/imei'
    | '/$locale/$partner/_device/reveal-imei'
    | '/$locale/$partner/_evaluation/audio'
    | '/$locale/$partner/_evaluation/biometrics'
    | '/$locale/$partner/_evaluation/digitizer'
    | '/$locale/$partner/_evaluation/gyroscope'
    | '/$locale/$partner/_evaluation/multitouch'
    | '/$locale/$partner/_onboarding/impact'
    | '/$locale/$partner/_onboarding/info'
    | '/$locale/$partner/_onboarding/start'
    | '/$locale/$partner/_onboarding/what-you-need'
    | '/$locale/$partner/_results/assessment-results'
    | '/$locale/$partner/_results/offer'
    | '/$locale/$partner/_results/stored-assessment-results'
    | '/$locale/$partner/_results/user-info'
    | '/$locale/$partner/_trade-in/store-locations'
    | '/$locale/$partner/_trade-in/trade-in-completion'
    | '/$locale/$partner/_trade-in/trade-in-completion-from-home'
    | '/$locale/$partner/_trade-in/trade-in-completion-on-vision'
    | '/$locale/$partner/_transitions/redirection'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LocaleRouteRoute: typeof LocaleRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale': {
      id: '/$locale'
      path: '/$locale'
      fullPath: '/$locale'
      preLoaderRoute: typeof LocaleRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/$partner': {
      id: '/$locale/$partner'
      path: '/$partner'
      fullPath: '/$locale/$partner'
      preLoaderRoute: typeof LocalePartnerRouteRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/$partner/': {
      id: '/$locale/$partner/'
      path: '/'
      fullPath: '/$locale/$partner/'
      preLoaderRoute: typeof LocalePartnerIndexRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/$pageType': {
      id: '/$locale/$partner/$pageType'
      path: '/$pageType'
      fullPath: '/$locale/$partner/$pageType'
      preLoaderRoute: typeof LocalePartnerPageTypeRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/_camera': {
      id: '/$locale/$partner/_camera'
      path: ''
      fullPath: '/$locale/$partner'
      preLoaderRoute: typeof LocalePartnerCameraRouteRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/_cosmetic': {
      id: '/$locale/$partner/_cosmetic'
      path: ''
      fullPath: '/$locale/$partner'
      preLoaderRoute: typeof LocalePartnerCosmeticRouteRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/_device': {
      id: '/$locale/$partner/_device'
      path: ''
      fullPath: '/$locale/$partner'
      preLoaderRoute: typeof LocalePartnerDeviceRouteRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/_evaluation': {
      id: '/$locale/$partner/_evaluation'
      path: ''
      fullPath: '/$locale/$partner'
      preLoaderRoute: typeof LocalePartnerEvaluationRouteRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/_onboarding': {
      id: '/$locale/$partner/_onboarding'
      path: ''
      fullPath: '/$locale/$partner'
      preLoaderRoute: typeof LocalePartnerOnboardingRouteRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/_results': {
      id: '/$locale/$partner/_results'
      path: ''
      fullPath: '/$locale/$partner'
      preLoaderRoute: typeof LocalePartnerResultsRouteRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/_trade-in': {
      id: '/$locale/$partner/_trade-in'
      path: ''
      fullPath: '/$locale/$partner'
      preLoaderRoute: typeof LocalePartnerTradeInRouteRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/_transitions': {
      id: '/$locale/$partner/_transitions'
      path: ''
      fullPath: '/$locale/$partner'
      preLoaderRoute: typeof LocalePartnerTransitionsRouteRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/add-assessments': {
      id: '/$locale/$partner/add-assessments'
      path: '/add-assessments'
      fullPath: '/$locale/$partner/add-assessments'
      preLoaderRoute: typeof LocalePartnerAddAssessmentsRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/_camera/back-camera-ai': {
      id: '/$locale/$partner/_camera/back-camera-ai'
      path: '/back-camera-ai'
      fullPath: '/$locale/$partner/back-camera-ai'
      preLoaderRoute: typeof LocalePartnerCameraBackCameraAiRouteImport
      parentRoute: typeof LocalePartnerCameraRouteRoute
    }
    '/$locale/$partner/_camera/front-camera-ai': {
      id: '/$locale/$partner/_camera/front-camera-ai'
      path: '/front-camera-ai'
      fullPath: '/$locale/$partner/front-camera-ai'
      preLoaderRoute: typeof LocalePartnerCameraFrontCameraAiRouteImport
      parentRoute: typeof LocalePartnerCameraRouteRoute
    }
    '/$locale/$partner/_cosmetic/self-back-cosmetics': {
      id: '/$locale/$partner/_cosmetic/self-back-cosmetics'
      path: '/self-back-cosmetics'
      fullPath: '/$locale/$partner/self-back-cosmetics'
      preLoaderRoute: typeof LocalePartnerCosmeticSelfBackCosmeticsRouteImport
      parentRoute: typeof LocalePartnerCosmeticRouteRoute
    }
    '/$locale/$partner/_cosmetic/self-body-frame-cosmetics': {
      id: '/$locale/$partner/_cosmetic/self-body-frame-cosmetics'
      path: '/self-body-frame-cosmetics'
      fullPath: '/$locale/$partner/self-body-frame-cosmetics'
      preLoaderRoute: typeof LocalePartnerCosmeticSelfBodyFrameCosmeticsRouteImport
      parentRoute: typeof LocalePartnerCosmeticRouteRoute
    }
    '/$locale/$partner/_cosmetic/self-buttons-work': {
      id: '/$locale/$partner/_cosmetic/self-buttons-work'
      path: '/self-buttons-work'
      fullPath: '/$locale/$partner/self-buttons-work'
      preLoaderRoute: typeof LocalePartnerCosmeticSelfButtonsWorkRouteImport
      parentRoute: typeof LocalePartnerCosmeticRouteRoute
    }
    '/$locale/$partner/_cosmetic/self-camera-cosmetics': {
      id: '/$locale/$partner/_cosmetic/self-camera-cosmetics'
      path: '/self-camera-cosmetics'
      fullPath: '/$locale/$partner/self-camera-cosmetics'
      preLoaderRoute: typeof LocalePartnerCosmeticSelfCameraCosmeticsRouteImport
      parentRoute: typeof LocalePartnerCosmeticRouteRoute
    }
    '/$locale/$partner/_cosmetic/self-front-cosmetics': {
      id: '/$locale/$partner/_cosmetic/self-front-cosmetics'
      path: '/self-front-cosmetics'
      fullPath: '/$locale/$partner/self-front-cosmetics'
      preLoaderRoute: typeof LocalePartnerCosmeticSelfFrontCosmeticsRouteImport
      parentRoute: typeof LocalePartnerCosmeticRouteRoute
    }
    '/$locale/$partner/_cosmetic/self-lcd-condition': {
      id: '/$locale/$partner/_cosmetic/self-lcd-condition'
      path: '/self-lcd-condition'
      fullPath: '/$locale/$partner/self-lcd-condition'
      preLoaderRoute: typeof LocalePartnerCosmeticSelfLcdConditionRouteImport
      parentRoute: typeof LocalePartnerCosmeticRouteRoute
    }
    '/$locale/$partner/_device/device-identified': {
      id: '/$locale/$partner/_device/device-identified'
      path: '/device-identified'
      fullPath: '/$locale/$partner/device-identified'
      preLoaderRoute: typeof LocalePartnerDeviceDeviceIdentifiedRouteImport
      parentRoute: typeof LocalePartnerDeviceRouteRoute
    }
    '/$locale/$partner/_device/imei': {
      id: '/$locale/$partner/_device/imei'
      path: '/imei'
      fullPath: '/$locale/$partner/imei'
      preLoaderRoute: typeof LocalePartnerDeviceImeiRouteImport
      parentRoute: typeof LocalePartnerDeviceRouteRoute
    }
    '/$locale/$partner/_device/reveal-imei': {
      id: '/$locale/$partner/_device/reveal-imei'
      path: '/reveal-imei'
      fullPath: '/$locale/$partner/reveal-imei'
      preLoaderRoute: typeof LocalePartnerDeviceRevealImeiRouteImport
      parentRoute: typeof LocalePartnerDeviceRouteRoute
    }
    '/$locale/$partner/_evaluation/audio': {
      id: '/$locale/$partner/_evaluation/audio'
      path: '/audio'
      fullPath: '/$locale/$partner/audio'
      preLoaderRoute: typeof LocalePartnerEvaluationAudioRouteImport
      parentRoute: typeof LocalePartnerEvaluationRouteRoute
    }
    '/$locale/$partner/_evaluation/biometrics': {
      id: '/$locale/$partner/_evaluation/biometrics'
      path: '/biometrics'
      fullPath: '/$locale/$partner/biometrics'
      preLoaderRoute: typeof LocalePartnerEvaluationBiometricsRouteImport
      parentRoute: typeof LocalePartnerEvaluationRouteRoute
    }
    '/$locale/$partner/_evaluation/digitizer': {
      id: '/$locale/$partner/_evaluation/digitizer'
      path: '/digitizer'
      fullPath: '/$locale/$partner/digitizer'
      preLoaderRoute: typeof LocalePartnerEvaluationDigitizerRouteImport
      parentRoute: typeof LocalePartnerEvaluationRouteRoute
    }
    '/$locale/$partner/_evaluation/gyroscope': {
      id: '/$locale/$partner/_evaluation/gyroscope'
      path: '/gyroscope'
      fullPath: '/$locale/$partner/gyroscope'
      preLoaderRoute: typeof LocalePartnerEvaluationGyroscopeRouteImport
      parentRoute: typeof LocalePartnerEvaluationRouteRoute
    }
    '/$locale/$partner/_evaluation/multitouch': {
      id: '/$locale/$partner/_evaluation/multitouch'
      path: '/multitouch'
      fullPath: '/$locale/$partner/multitouch'
      preLoaderRoute: typeof LocalePartnerEvaluationMultitouchRouteImport
      parentRoute: typeof LocalePartnerEvaluationRouteRoute
    }
    '/$locale/$partner/_onboarding/impact': {
      id: '/$locale/$partner/_onboarding/impact'
      path: '/impact'
      fullPath: '/$locale/$partner/impact'
      preLoaderRoute: typeof LocalePartnerOnboardingImpactRouteImport
      parentRoute: typeof LocalePartnerOnboardingRouteRoute
    }
    '/$locale/$partner/_onboarding/info': {
      id: '/$locale/$partner/_onboarding/info'
      path: '/info'
      fullPath: '/$locale/$partner/info'
      preLoaderRoute: typeof LocalePartnerOnboardingInfoRouteImport
      parentRoute: typeof LocalePartnerOnboardingRouteRoute
    }
    '/$locale/$partner/_onboarding/start': {
      id: '/$locale/$partner/_onboarding/start'
      path: '/start'
      fullPath: '/$locale/$partner/start'
      preLoaderRoute: typeof LocalePartnerOnboardingStartRouteImport
      parentRoute: typeof LocalePartnerOnboardingRouteRoute
    }
    '/$locale/$partner/_onboarding/what-you-need': {
      id: '/$locale/$partner/_onboarding/what-you-need'
      path: '/what-you-need'
      fullPath: '/$locale/$partner/what-you-need'
      preLoaderRoute: typeof LocalePartnerOnboardingWhatYouNeedRouteImport
      parentRoute: typeof LocalePartnerOnboardingRouteRoute
    }
    '/$locale/$partner/_results/assessment-results': {
      id: '/$locale/$partner/_results/assessment-results'
      path: '/assessment-results'
      fullPath: '/$locale/$partner/assessment-results'
      preLoaderRoute: typeof LocalePartnerResultsAssessmentResultsRouteImport
      parentRoute: typeof LocalePartnerResultsRouteRoute
    }
    '/$locale/$partner/_results/offer': {
      id: '/$locale/$partner/_results/offer'
      path: '/offer'
      fullPath: '/$locale/$partner/offer'
      preLoaderRoute: typeof LocalePartnerResultsOfferRouteImport
      parentRoute: typeof LocalePartnerResultsRouteRoute
    }
    '/$locale/$partner/_results/stored-assessment-results': {
      id: '/$locale/$partner/_results/stored-assessment-results'
      path: '/stored-assessment-results'
      fullPath: '/$locale/$partner/stored-assessment-results'
      preLoaderRoute: typeof LocalePartnerResultsStoredAssessmentResultsRouteImport
      parentRoute: typeof LocalePartnerResultsRouteRoute
    }
    '/$locale/$partner/_results/user-info': {
      id: '/$locale/$partner/_results/user-info'
      path: '/user-info'
      fullPath: '/$locale/$partner/user-info'
      preLoaderRoute: typeof LocalePartnerResultsUserInfoRouteImport
      parentRoute: typeof LocalePartnerResultsRouteRoute
    }
    '/$locale/$partner/_trade-in/store-locations': {
      id: '/$locale/$partner/_trade-in/store-locations'
      path: '/store-locations'
      fullPath: '/$locale/$partner/store-locations'
      preLoaderRoute: typeof LocalePartnerTradeInStoreLocationsRouteImport
      parentRoute: typeof LocalePartnerTradeInRouteRoute
    }
    '/$locale/$partner/_trade-in/trade-in-completion': {
      id: '/$locale/$partner/_trade-in/trade-in-completion'
      path: '/trade-in-completion'
      fullPath: '/$locale/$partner/trade-in-completion'
      preLoaderRoute: typeof LocalePartnerTradeInTradeInCompletionRouteImport
      parentRoute: typeof LocalePartnerTradeInRouteRoute
    }
    '/$locale/$partner/_trade-in/trade-in-completion-from-home': {
      id: '/$locale/$partner/_trade-in/trade-in-completion-from-home'
      path: '/trade-in-completion-from-home'
      fullPath: '/$locale/$partner/trade-in-completion-from-home'
      preLoaderRoute: typeof LocalePartnerTradeInTradeInCompletionFromHomeRouteImport
      parentRoute: typeof LocalePartnerTradeInRouteRoute
    }
    '/$locale/$partner/_trade-in/trade-in-completion-on-vision': {
      id: '/$locale/$partner/_trade-in/trade-in-completion-on-vision'
      path: '/trade-in-completion-on-vision'
      fullPath: '/$locale/$partner/trade-in-completion-on-vision'
      preLoaderRoute: typeof LocalePartnerTradeInTradeInCompletionOnVisionRouteImport
      parentRoute: typeof LocalePartnerTradeInRouteRoute
    }
    '/$locale/$partner/_transitions/redirection': {
      id: '/$locale/$partner/_transitions/redirection'
      path: '/redirection'
      fullPath: '/$locale/$partner/redirection'
      preLoaderRoute: typeof LocalePartnerTransitionsRedirectionRouteImport
      parentRoute: typeof LocalePartnerTransitionsRouteRoute
    }
  }
}

interface LocalePartnerCameraRouteRouteChildren {
  LocalePartnerCameraBackCameraAiRoute: typeof LocalePartnerCameraBackCameraAiRoute
  LocalePartnerCameraFrontCameraAiRoute: typeof LocalePartnerCameraFrontCameraAiRoute
}

const LocalePartnerCameraRouteRouteChildren: LocalePartnerCameraRouteRouteChildren =
  {
    LocalePartnerCameraBackCameraAiRoute: LocalePartnerCameraBackCameraAiRoute,
    LocalePartnerCameraFrontCameraAiRoute:
      LocalePartnerCameraFrontCameraAiRoute,
  }

const LocalePartnerCameraRouteRouteWithChildren =
  LocalePartnerCameraRouteRoute._addFileChildren(
    LocalePartnerCameraRouteRouteChildren,
  )

interface LocalePartnerCosmeticRouteRouteChildren {
  LocalePartnerCosmeticSelfBackCosmeticsRoute: typeof LocalePartnerCosmeticSelfBackCosmeticsRoute
  LocalePartnerCosmeticSelfBodyFrameCosmeticsRoute: typeof LocalePartnerCosmeticSelfBodyFrameCosmeticsRoute
  LocalePartnerCosmeticSelfButtonsWorkRoute: typeof LocalePartnerCosmeticSelfButtonsWorkRoute
  LocalePartnerCosmeticSelfCameraCosmeticsRoute: typeof LocalePartnerCosmeticSelfCameraCosmeticsRoute
  LocalePartnerCosmeticSelfFrontCosmeticsRoute: typeof LocalePartnerCosmeticSelfFrontCosmeticsRoute
  LocalePartnerCosmeticSelfLcdConditionRoute: typeof LocalePartnerCosmeticSelfLcdConditionRoute
}

const LocalePartnerCosmeticRouteRouteChildren: LocalePartnerCosmeticRouteRouteChildren =
  {
    LocalePartnerCosmeticSelfBackCosmeticsRoute:
      LocalePartnerCosmeticSelfBackCosmeticsRoute,
    LocalePartnerCosmeticSelfBodyFrameCosmeticsRoute:
      LocalePartnerCosmeticSelfBodyFrameCosmeticsRoute,
    LocalePartnerCosmeticSelfButtonsWorkRoute:
      LocalePartnerCosmeticSelfButtonsWorkRoute,
    LocalePartnerCosmeticSelfCameraCosmeticsRoute:
      LocalePartnerCosmeticSelfCameraCosmeticsRoute,
    LocalePartnerCosmeticSelfFrontCosmeticsRoute:
      LocalePartnerCosmeticSelfFrontCosmeticsRoute,
    LocalePartnerCosmeticSelfLcdConditionRoute:
      LocalePartnerCosmeticSelfLcdConditionRoute,
  }

const LocalePartnerCosmeticRouteRouteWithChildren =
  LocalePartnerCosmeticRouteRoute._addFileChildren(
    LocalePartnerCosmeticRouteRouteChildren,
  )

interface LocalePartnerDeviceRouteRouteChildren {
  LocalePartnerDeviceDeviceIdentifiedRoute: typeof LocalePartnerDeviceDeviceIdentifiedRoute
  LocalePartnerDeviceImeiRoute: typeof LocalePartnerDeviceImeiRoute
  LocalePartnerDeviceRevealImeiRoute: typeof LocalePartnerDeviceRevealImeiRoute
}

const LocalePartnerDeviceRouteRouteChildren: LocalePartnerDeviceRouteRouteChildren =
  {
    LocalePartnerDeviceDeviceIdentifiedRoute:
      LocalePartnerDeviceDeviceIdentifiedRoute,
    LocalePartnerDeviceImeiRoute: LocalePartnerDeviceImeiRoute,
    LocalePartnerDeviceRevealImeiRoute: LocalePartnerDeviceRevealImeiRoute,
  }

const LocalePartnerDeviceRouteRouteWithChildren =
  LocalePartnerDeviceRouteRoute._addFileChildren(
    LocalePartnerDeviceRouteRouteChildren,
  )

interface LocalePartnerEvaluationRouteRouteChildren {
  LocalePartnerEvaluationAudioRoute: typeof LocalePartnerEvaluationAudioRoute
  LocalePartnerEvaluationBiometricsRoute: typeof LocalePartnerEvaluationBiometricsRoute
  LocalePartnerEvaluationDigitizerRoute: typeof LocalePartnerEvaluationDigitizerRoute
  LocalePartnerEvaluationGyroscopeRoute: typeof LocalePartnerEvaluationGyroscopeRoute
  LocalePartnerEvaluationMultitouchRoute: typeof LocalePartnerEvaluationMultitouchRoute
}

const LocalePartnerEvaluationRouteRouteChildren: LocalePartnerEvaluationRouteRouteChildren =
  {
    LocalePartnerEvaluationAudioRoute: LocalePartnerEvaluationAudioRoute,
    LocalePartnerEvaluationBiometricsRoute:
      LocalePartnerEvaluationBiometricsRoute,
    LocalePartnerEvaluationDigitizerRoute:
      LocalePartnerEvaluationDigitizerRoute,
    LocalePartnerEvaluationGyroscopeRoute:
      LocalePartnerEvaluationGyroscopeRoute,
    LocalePartnerEvaluationMultitouchRoute:
      LocalePartnerEvaluationMultitouchRoute,
  }

const LocalePartnerEvaluationRouteRouteWithChildren =
  LocalePartnerEvaluationRouteRoute._addFileChildren(
    LocalePartnerEvaluationRouteRouteChildren,
  )

interface LocalePartnerOnboardingRouteRouteChildren {
  LocalePartnerOnboardingImpactRoute: typeof LocalePartnerOnboardingImpactRoute
  LocalePartnerOnboardingInfoRoute: typeof LocalePartnerOnboardingInfoRoute
  LocalePartnerOnboardingStartRoute: typeof LocalePartnerOnboardingStartRoute
  LocalePartnerOnboardingWhatYouNeedRoute: typeof LocalePartnerOnboardingWhatYouNeedRoute
}

const LocalePartnerOnboardingRouteRouteChildren: LocalePartnerOnboardingRouteRouteChildren =
  {
    LocalePartnerOnboardingImpactRoute: LocalePartnerOnboardingImpactRoute,
    LocalePartnerOnboardingInfoRoute: LocalePartnerOnboardingInfoRoute,
    LocalePartnerOnboardingStartRoute: LocalePartnerOnboardingStartRoute,
    LocalePartnerOnboardingWhatYouNeedRoute:
      LocalePartnerOnboardingWhatYouNeedRoute,
  }

const LocalePartnerOnboardingRouteRouteWithChildren =
  LocalePartnerOnboardingRouteRoute._addFileChildren(
    LocalePartnerOnboardingRouteRouteChildren,
  )

interface LocalePartnerResultsRouteRouteChildren {
  LocalePartnerResultsAssessmentResultsRoute: typeof LocalePartnerResultsAssessmentResultsRoute
  LocalePartnerResultsOfferRoute: typeof LocalePartnerResultsOfferRoute
  LocalePartnerResultsStoredAssessmentResultsRoute: typeof LocalePartnerResultsStoredAssessmentResultsRoute
  LocalePartnerResultsUserInfoRoute: typeof LocalePartnerResultsUserInfoRoute
}

const LocalePartnerResultsRouteRouteChildren: LocalePartnerResultsRouteRouteChildren =
  {
    LocalePartnerResultsAssessmentResultsRoute:
      LocalePartnerResultsAssessmentResultsRoute,
    LocalePartnerResultsOfferRoute: LocalePartnerResultsOfferRoute,
    LocalePartnerResultsStoredAssessmentResultsRoute:
      LocalePartnerResultsStoredAssessmentResultsRoute,
    LocalePartnerResultsUserInfoRoute: LocalePartnerResultsUserInfoRoute,
  }

const LocalePartnerResultsRouteRouteWithChildren =
  LocalePartnerResultsRouteRoute._addFileChildren(
    LocalePartnerResultsRouteRouteChildren,
  )

interface LocalePartnerTradeInRouteRouteChildren {
  LocalePartnerTradeInStoreLocationsRoute: typeof LocalePartnerTradeInStoreLocationsRoute
  LocalePartnerTradeInTradeInCompletionRoute: typeof LocalePartnerTradeInTradeInCompletionRoute
  LocalePartnerTradeInTradeInCompletionFromHomeRoute: typeof LocalePartnerTradeInTradeInCompletionFromHomeRoute
  LocalePartnerTradeInTradeInCompletionOnVisionRoute: typeof LocalePartnerTradeInTradeInCompletionOnVisionRoute
}

const LocalePartnerTradeInRouteRouteChildren: LocalePartnerTradeInRouteRouteChildren =
  {
    LocalePartnerTradeInStoreLocationsRoute:
      LocalePartnerTradeInStoreLocationsRoute,
    LocalePartnerTradeInTradeInCompletionRoute:
      LocalePartnerTradeInTradeInCompletionRoute,
    LocalePartnerTradeInTradeInCompletionFromHomeRoute:
      LocalePartnerTradeInTradeInCompletionFromHomeRoute,
    LocalePartnerTradeInTradeInCompletionOnVisionRoute:
      LocalePartnerTradeInTradeInCompletionOnVisionRoute,
  }

const LocalePartnerTradeInRouteRouteWithChildren =
  LocalePartnerTradeInRouteRoute._addFileChildren(
    LocalePartnerTradeInRouteRouteChildren,
  )

interface LocalePartnerTransitionsRouteRouteChildren {
  LocalePartnerTransitionsRedirectionRoute: typeof LocalePartnerTransitionsRedirectionRoute
}

const LocalePartnerTransitionsRouteRouteChildren: LocalePartnerTransitionsRouteRouteChildren =
  {
    LocalePartnerTransitionsRedirectionRoute:
      LocalePartnerTransitionsRedirectionRoute,
  }

const LocalePartnerTransitionsRouteRouteWithChildren =
  LocalePartnerTransitionsRouteRoute._addFileChildren(
    LocalePartnerTransitionsRouteRouteChildren,
  )

interface LocalePartnerRouteRouteChildren {
  LocalePartnerCameraRouteRoute: typeof LocalePartnerCameraRouteRouteWithChildren
  LocalePartnerCosmeticRouteRoute: typeof LocalePartnerCosmeticRouteRouteWithChildren
  LocalePartnerDeviceRouteRoute: typeof LocalePartnerDeviceRouteRouteWithChildren
  LocalePartnerEvaluationRouteRoute: typeof LocalePartnerEvaluationRouteRouteWithChildren
  LocalePartnerOnboardingRouteRoute: typeof LocalePartnerOnboardingRouteRouteWithChildren
  LocalePartnerResultsRouteRoute: typeof LocalePartnerResultsRouteRouteWithChildren
  LocalePartnerTradeInRouteRoute: typeof LocalePartnerTradeInRouteRouteWithChildren
  LocalePartnerTransitionsRouteRoute: typeof LocalePartnerTransitionsRouteRouteWithChildren
  LocalePartnerPageTypeRoute: typeof LocalePartnerPageTypeRoute
  LocalePartnerAddAssessmentsRoute: typeof LocalePartnerAddAssessmentsRoute
  LocalePartnerIndexRoute: typeof LocalePartnerIndexRoute
}

const LocalePartnerRouteRouteChildren: LocalePartnerRouteRouteChildren = {
  LocalePartnerCameraRouteRoute: LocalePartnerCameraRouteRouteWithChildren,
  LocalePartnerCosmeticRouteRoute: LocalePartnerCosmeticRouteRouteWithChildren,
  LocalePartnerDeviceRouteRoute: LocalePartnerDeviceRouteRouteWithChildren,
  LocalePartnerEvaluationRouteRoute:
    LocalePartnerEvaluationRouteRouteWithChildren,
  LocalePartnerOnboardingRouteRoute:
    LocalePartnerOnboardingRouteRouteWithChildren,
  LocalePartnerResultsRouteRoute: LocalePartnerResultsRouteRouteWithChildren,
  LocalePartnerTradeInRouteRoute: LocalePartnerTradeInRouteRouteWithChildren,
  LocalePartnerTransitionsRouteRoute:
    LocalePartnerTransitionsRouteRouteWithChildren,
  LocalePartnerPageTypeRoute: LocalePartnerPageTypeRoute,
  LocalePartnerAddAssessmentsRoute: LocalePartnerAddAssessmentsRoute,
  LocalePartnerIndexRoute: LocalePartnerIndexRoute,
}

const LocalePartnerRouteRouteWithChildren =
  LocalePartnerRouteRoute._addFileChildren(LocalePartnerRouteRouteChildren)

interface LocaleRouteRouteChildren {
  LocalePartnerRouteRoute: typeof LocalePartnerRouteRouteWithChildren
}

const LocaleRouteRouteChildren: LocaleRouteRouteChildren = {
  LocalePartnerRouteRoute: LocalePartnerRouteRouteWithChildren,
}

const LocaleRouteRouteWithChildren = LocaleRouteRoute._addFileChildren(
  LocaleRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LocaleRouteRoute: LocaleRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
